module.exports = __webpack_public_path__ + "static/media/KY.6800896b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KY.svg
// module id = 2191
// module chunks = 7